// extracted by mini-css-extract-plugin
export default {"row":"Home_row__8MLZD","loadingWrapper":"Home_loadingWrapper__ks2aW","colLeft":"Home_colLeft__+97um","colRight":"Home_colRight__J9hrv","col":"Home_col__UKVec"};